import React, { useState } from "react";
import { useAuthContext } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { apiRequest } from "../utils/api";
import { useAlert } from '../components/AlertModal';
import "../styles/LoginForm.css";

const LoginForm = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [registers, setRegisters] = useState([]);
  const { setUser } = useAuthContext();
  const { showAlert } = useAlert();
  const navigate = useNavigate();
  // 2FA
  const [twoFactorMode, setTwoFactorMode] = useState(null); // "setup" or "login"
  const [tempUserId, setTempUserId] = useState(null);
  const [qrBase64, setQrBase64] = useState("");
  const [twoFactorCode, setTwoFactorCode] = useState("");
  const [backupCodes, setBackupCodes] = useState([]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMsg("");

    try {
      // ✅ JWTトークン取得
      const res = await apiRequest("accounts/login/", "POST", { username, password });
      
      if (res.two_factor_required) {
        setTempUserId(res.temp_user_id);

        if (res.two_factor_setup_required) {
          const setupRes = await apiRequest("accounts/2fa/setup/", "POST", {
            temp_user_id: res.temp_user_id,
          });

          setQrBase64(setupRes.qr_base64);
          setTwoFactorMode("setup");
        } else {
          setTwoFactorMode("login");
        }

        return;
      }
      localStorage.setItem("access", res.access);
      localStorage.setItem("refresh", res.refresh);

      // ✅ ユーザー情報取得
      const user = await apiRequest("accounts/me/");
      setUser(user);

      // ✅ レジ未設定 → 選択モーダル表示
      if (!user.register_id) {
        setShowModal(true);
        const res = await apiRequest("inventory/registers/");
        setRegisters(res);
      } else {
        navigate("/");
      }
    } catch (err) {
      setErrorMsg("ログイン失敗しました");
      console.error("Login failed:", err);
    }
  };

  const handleSelectRegister = async (registerId) => {
    try {
      await apiRequest("accounts/set_register/", "POST", { register_id: registerId });
      setShowModal(false);
      navigate("/");
    } catch (err) {
      showAlert("レジの登録に失敗しました");
    }
  };
  
  // ✅ 2FA送信用関数
  const handleTwoFactorSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg("");

    try {
      const endpoint =
        twoFactorMode === "setup"
          ? "accounts/2fa/verify-setup/"
          : "accounts/2fa/verify-login/";

      const res = await apiRequest(endpoint, "POST", {
        temp_user_id: tempUserId,
        code: twoFactorCode,
      });

      localStorage.setItem("access", res.access);
      localStorage.setItem("refresh", res.refresh);

      if (res.backup_codes) {
        setBackupCodes(res.backup_codes);
        return;
      }

      const user = await apiRequest("accounts/me/");
      setUser(user);

      if (!user.register_id) {
        setShowModal(true);
        const registersRes = await apiRequest("inventory/registers/");
        setRegisters(registersRes);
      } else {
        navigate("/");
      }
    } catch (err) {
      setErrorMsg("2FA認証に失敗しました");
      console.error("2FA failed:", err);
    }
  };
  if (twoFactorMode) {
    return (
      <div className="LoginForm-login-form">
        <h2>2段階認証</h2>

        {twoFactorMode === "setup" && (
          <>
            <p>Google AuthenticatorでQRコードを読み取ってください。</p>
            {qrBase64 && <img src={qrBase64} alt="2FA QRコード" />}
          </>
        )}

        <form onSubmit={handleTwoFactorSubmit}>
          <input
            type="text"
            placeholder="6桁コード または バックアップコード"
            value={twoFactorCode}
            onChange={(e) => setTwoFactorCode(e.target.value)}
          />
          <button type="submit">認証する</button>
        </form>

        {errorMsg && <p className="error">{errorMsg}</p>}

        {backupCodes.length > 0 && (
          <div>
            <h3>バックアップコード</h3>
            <p>このコードは再表示できません。必ず保存してください。</p>
            <ul>
              {backupCodes.map((code) => (
                <li key={code}>{code}</li>
              ))}
            </ul>
            <button onClick={() => navigate("/")}>保存したので進む</button>
          </div>
        )}
      </div>
    );
  }
  return (
    <div className="LoginForm-login-form">
      <h2>ログイン</h2>
      <form onSubmit={handleLogin}>
        <input
          type="text"
          placeholder="ユーザー名"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <input
          type="password"
          placeholder="パスワード"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button type="submit">ログイン</button>
      </form>
      {errorMsg && <p className="error">{errorMsg}</p>}

      {showModal && (
        <div className="LoginForm-modal-overlay">
          <div className="LoginForm-modal">
            <h3>レジを選択してください</h3>
            <ul>
              {registers.map((reg) => (
                <li key={reg.id}>
                  <button onClick={() => handleSelectRegister(reg.id)}>{reg.name}</button>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default LoginForm;
